const routes = {
  login: '/login',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  home: '/home',
  events: '/events',
  eventDetail: '/events',
  hostEvent: '/events/hostevent',
  jobs: '/jobs',
  jobDetails: '/jobs',
  postJob: '/jobs/postjob',
  mentorship: '/mentorship',
  fundraise: '/fundraise',
  fundraiseDetails: '/fundraise',
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  createGroup: '/groups/create-group',
  network: '/network',
  survey: '/survey',
  interview: '/interview',
  scoresheet: '/interview/scoresheet',
  createSurvey: '/survey/create-survey',
  test: '/test',
  service: '/service',
  RequestService: '/service/RequestService',
  Answers: '/service/Answers',
  TicketPreview: '/service/TicketPreview',
};

export default routes;
